import { get, post } from "@/utils/request";
// 获取流程列表
export const getFlowList = (params:any) => post('/api/companyFlow/pagelist', params)
